import { DeviceTypeList } from "@kg-pos/common";
import { DeviceDataFragment, DeviceResponse } from "__generated__/graphql";

export const getDeviceRecord = (
  device: DeviceDataFragment
): Omit<DeviceResponse, "type"> & { type: string } => ({
  ...device,
  type: DeviceTypeList[device.type],
});
